<template lang="pug">
    #loginPage
        .header-nav
            a(href="/")
                img(:src="wlLogo")
            a.contact-us.waves-effect.waves-light(:href='wlContact') Contact
        .login-cards
            .login-card.step-login(v-show="step == 0")
                .content(data-step='0')
                    .title Welcome to {{wlName}}
                    
                    
                    .input-group
                        HaqTextField#login-email(name='login-email' type='email' v-model="username" @input="handleEmailInput" label="Email Address" placeholder="Enter your email address" hide-details)
                    .input-group
                        HaqTextField#login-password(name='login-password' type='password' v-model="password" label="Password" placeholder="Enter your password" hide-details)
                    .error(v-if="errorText") {{errorText}}
                    button#loginBtn.waves-effect.waves-light(v-on:click="fetchProjects") Login

                    //- Divider
                    .auth-divider
                        span or

                    //- SAML Error Display
                    .error-banner(v-if="samlError")
                        .error-content
                            i.material-icons warning
                            span {{ samlError }}
                            button.error-close(@click="clearSamlError") ×
                    
                    //- CPS Login Suggestion
                    .cps-login-suggestion(v-if="suggestSamlLogin")
                        .suggestion-text
                            | Looks like you have a CPS email address. You can sign in using CPS SSO.
                        .suggestion-actions
                            button.btn.btn-primary.btn-small(@click="redirectToSamlLogin") Sign in with CPS
                            button.btn.btn-secondary.btn-small(@click="suggestSamlLogin = false") Continue with password
                    
                    //- SAML Login Section
                    .saml-login-section
                        button.saml-login-btn(@click="redirectToSamlLogin" :disabled="samlLoading")
                            i.material-icons(v-if="!samlLoading") school
                            i.material-icons(v-if="samlLoading") hourglass_empty
                            span(v-if="!samlLoading") Sign in with CPS
                            span(v-if="samlLoading") Redirecting...

                    a(v-on:click="showResetPassword = true") Forgot Password?
                    
                    //- .strike
                    //-     span or
                    //- a#googleBtn.waves-effect.waves-light(href="/users/auth/google")
                    //-     <img src="/images/google/google-login.svg"> Sign In with Google
            .login-card.step-login(v-show="step == 3")
                .content(data-step='3').reset-password
                    .title Welcome to {{wlName}}
                    .subtitle Reset your password!
                    br
                    .input-field
                        label(for='login-email') New Password
                        input#new-password(name='login-email',v-model="resetPasswordInput.newPassword" placeholder="Enter your new password"
                        :type="resetPasswordInput.togglePassword ? 'text' : 'password'")
                        span.field-icon(@click="togglePasswordInput('password')")
                            span.material-icons(v-if="resetPasswordInput.togglePassword") visibility
                            span.material-icons(v-else="resetPasswordInput.togglePassword") visibility_off
                    .input-field.if-pw-confirm
                        label(for='login-email') Confirm Password
                        input#confirm-password(name='login-email', v-model="resetPasswordInput.confirmPassword" placeholder="Confirm your new password"
                        :type="resetPasswordInput.toggleConfirmPassword ? 'text' : 'password'"
                        )
                        span.field-icon(@click="togglePasswordInput('')")
                            span.material-icons(v-if="resetPasswordInput.toggleConfirmPassword") visibility
                            span.material-icons(v-else="resetPasswordInput.toggleConfirmPassword") visibility_off
                    button#reset-password-button.waves-effect.waves-light(@click="confirmResetPassword" :disabled="apiDisableButton") Reset Password
            .login-card.step-project(v-show="step == 1")
                .content(data-step='1')
                    .title Select a Project
                    .input-group
                        HaqSelect#selectProject2(
                            v-model="projectId"
                            :items="projects"
                            item-text="name"
                            item-value="objectId"
                            label="Select a Project"
                            hide-details
                            :menu-props="{ bottom: true, offsetY: true, closeOnClick: true, closeOnContentClick: true, contentClass: 'login-haq-select-menu' }")
                    button#chooseProjectBtn.waves-effect.waves-light(v-on:click="authenticateAPI") Confirm
                    .strike
                        span or
                    button#createProjectBtn.waves-effect.waves-light(v-on:click="moveToCreateProjectUI") Create Project
            .login-card.step-login(v-show="step == 2")
                .content(data-step='2')
                    .title Create Your Project
                    .input-group
                        HaqTextField#login-pname(name='login-pname' type='text' v-model="pname" label="Project Name" placeholder="Enter a project name")
                    .error(v-if="errorText") {{errorText}}
                    button#confirmCreateProject.waves-effect.waves-light(v-on:click="submitCreateProject") Create Project
        v-dialog(v-model="showResetPassword" max-width="400px" scrollable @click:outside="showResetPassword = false" content-class="haq-dialog reset-password-modal")
            v-card.haq-dialog-card(data-card)
                v-card-title 
                    h5 Forgot Password
                v-card-text(v-if="resetPasswordStep == 'send-email'")
                    p(v-if="resetPasswordInput.emailText") {{resetPasswordInput.emailText}}
                    HaqTextField#reset-email(name='login-email' type='email' v-model="username" label="Email Address" placeholder="Enter your email address")
                v-card-actions
                    v-spacer
                    v-btn.haq-btn.haq-btn-primary#reset-password-button(@click="resetPasswordSendEmail" v-if="resetPasswordStep == 'send-email'" :disabled="apiDisableButton") Reset Password
                    v-btn.haq-btn.haq-btn-primary(@click="confirmResetPassword" v-if="resetPasswordStep == 'reset-password'" :disabled="apiDisableButton") Reset Password

</template>
<script>
// @ is an alias to /src
import {wlData} from '../assets/js/constants';
import {HTTPClient} from '../assets/js/http';
import HaqSelect from '@/components/form/HaqSelect.vue';
import HaqTextField from '@/components/form/HaqTextField.vue';
let client = new HTTPClient();

export default {
    name: 'Login',
    components: {
        HaqSelect,
        HaqTextField
    },
    mounted(){
        if(this.autologin)
            $('#loginBtn').trigger('click');
        
        // Check for SAML errors
        this.checkForSamlError();
        this.returnToFromIfLoggedIn();
    },
    data() {
        return {
            username: this.$route.query.username||'',
            password: this.$route.query.password||'',
            autologin: (this.$route.query.al=='true')||false,
            errorText: null,
            projectId: '',
            projects: [],
            step: this.$route.query.resetPasswordToken ? 3 : 0,
            pname: '',
            onboardNewUser: false,
            wlName: wlData.name ? wlData.name : "HawkenAQ",
            wlLogo: wlData.loginLogo ? wlData.loginLogo : "/images/hawkenAqBlue.png",
            wlContact: wlData.contactUrl||'https://gethawken.com/contact-hawkenaq',
            showResetPassword: false,
            resetPasswordStep: 'send-email',
            apiDisableButton: false,
            resetPasswordInput: {
                emailText: "Enter your email address to reset your password",
                newPassword: '',
                confirmPassword: '',
                togglePassword: false,
                toggleConfirmPassword: false,
                error: null
            },
            samlError: null,
            samlLoading: false,
            suggestSamlLogin: false,
        };
    },
    methods: {
        /**
         * Send an already-logged-in user back to Portfolio Manager (or other app).
         * @description If the login URL has an absolute `from` and a session cookie exists, leave /login.
         */
        returnToFromIfLoggedIn() {
            const from = this.$route.query.from;
            if (!this.$store.getters.isLoggedIn || !from || from === 'onboarding') {
                return;
            }
            if (from.indexOf('http://') === 0 || from.indexOf('https://') === 0) {
                window.location.replace(from);
            }
        },
        async submitCreateProject(event){
            try{
                event.target.disabled = true;
                let username = this.username.toLowerCase().trim();
                let password = this.password;
                let pname = this.pname.trim();
                if (!pname){
                    window.M.toast({html: 'Enter your a project name'});
                    event.target.disabled = false;
                    return;
                }
                let project = await client.robustPost('/users/projects', {username, password, name: pname});
                project = project.results;

                await this.$store.dispatch('login', {username, password, project: project.objectId});
                    
                if(this.$route.query.from == "onboarding")
                    window.location.replace('/onboarding');
                else if (this.$route.query.from) //used to return to Admin
                    window.location.replace(this.$route.query.from);
                else
                    window.location.replace('/');
                // event.target.disabled = false;
            } catch (error) {
                console.error(error);
                event.target.disabled = false;
                this.errorText = error.message||'Login failed';
            }
        },
        async moveToCreateProjectUI(){
            this.step = 2;
        },
        async fetchProjects(event){
            try {
                event.target.disabled = true;
                let username = this.username.toLowerCase().trim();
                let password = this.password;

                if (!username || !password){
                    window.M.toast({html: 'Enter your Email and/or Password'});
                    event.target.disabled = false;
                }
                else {
                    let projects = await client.robustQuery('/users/projectsWithAuth', {username, password});
                    
                    if (projects.length >= 1) {
                        // sort projects by name
                        projects.sort((a,b) => {
                            if (a.name < b.name) return -1;
                            if (a.name > b.name) return 1;
                            return 0;
                        });
                        this.projects = projects;
                        this.step = 1;
                        this.$nextTick(() => {
                            let elems = document.querySelector("#selectProject");
                            window.M.FormSelect.init(elems,{});
                        })
                        event.target.disabled = false;
                    }
                    else if (projects.length == 1) {
                        // removed this because it prevents user from seeing create project button
                        this.projectId = projects[0].objectId;
                        this.authenticateAPI(event);
                    }
                    else {
                        // window.M.toast({html: 'There are no currently no projects assigned to your account.'});
                        // event.target.disabled = false;
                        this.projects = projects;
                        this.step = 1;
                        this.$nextTick(() => {
                            let elems = document.querySelector("#selectProject");
                            window.M.FormSelect.init(elems,{});
                        })
                        event.target.disabled = false;
                    }
                }
            } catch (error) {
                console.error(error);
                event.target.disabled = false;
                this.errorText = error.message||'Login failed';
            }
        },
        togglePasswordInput(input){
           if(input == 'password') {
             this.resetPasswordInput.togglePassword = !this.resetPasswordInput.togglePassword;
           } else {
                this.resetPasswordInput.toggleConfirmPassword = !this.resetPasswordInput.toggleConfirmPassword;
           }
        },
        async resetPasswordSendEmail(){
            this.apiDisableButton = true;
            try {
                let payload = {
                    email: this.username.toLowerCase().trim(),
                }
                await client.robustPost('/users/reset-password-email', payload);
                this.resetPasswordInput.emailText = 'Request received. Check your email'
                window.M.toast({html: 'Request received. Check your email'});
            } catch (error) {
                window.M.toast({html: 'Error sending email. Please make sure that is a registered email address.'});
            } finally {
                this.apiDisableButton = false;
            }
        },
        async confirmResetPassword() {
            try {
                if(this.$route.query.resetPasswordToken == null){
                    window.M.toast({html: 'Error resetting password. Please make sure that link is correct and has not expired.'});
                    return false;
                }
                if(this.resetPasswordInput.newPassword == "" || this.resetPasswordInput.confirmPassword == ""){
                    window.M.toast({html: 'Please enter your new password.'});
                    this.resetPasswordInput.error = "Please enter your new password.";
                    return false;
                }
                if(this.resetPasswordInput.newPassword != this.resetPasswordInput.confirmPassword){
                    window.M.toast({html: 'Passwords do not match.'});
                    this.resetPasswordInput.error = "Passwords do not match.";
                    return false;
                }

                let payload = {
                    email: this.username.toLowerCase().trim(),
                    password: this.resetPasswordInput.newPassword,
                    token: this.$route.query.resetPasswordToken
                }
                this.apiDisableButton = true;
                const res = await client.robustPost('/users/reset-password', payload);
                console.log(res);
                const { email } = res.results
                window.M.toast({html: 'Password reset successfully. Please login now'});
                setTimeout(() => {
                    window.location.replace('/login?username=' + email);
                }, 500)

            } catch (error) {
                console.error(error);
                window.M.toast({html: 'Error resetting password. Please make sure that the one time password is correct and has not expired.'});
            } finally {
                this.apiDisableButton = false;
                this.resetPasswordInput.error = null;
            }
        },
        async authenticateAPI(event) {
            event.target.disabled = true;
            try {
                let username = this.username.toLowerCase().trim();
                let password = this.password;
                let project = this.projectId;

                if (!project){
                    window.M.toast({html: 'Select a Project'});
                    event.target.disabled = false;
                }
                else {
                    await this.$store.dispatch('login', {username, password, project});
                    
                    if(this.$route.query.from == "onboarding")
                        window.location.replace('/onboarding');
                    else if (this.$route.query.from) //used to return to Admin
                        window.location.replace(this.$route.query.from);
                    else
                        window.location.replace('/');
                }
            } catch (error) {
                console.error(error);
                event.target.disabled = false;
                this.errorText = true;
            }
        },
        redirectToSamlLogin() {
             this.samlLoading = true;
             this.samlError = null;
             
             // Track SAML login attempt
             this.trackSamlLogin();
             
             // Add small delay to show loading state
             setTimeout(() => {
                 window.location.href = '/users/auth/saml';
             }, 500);
         },
                 handleEmailInput() {
             this.suggestSamlLogin = false;
             if (this.username && this.username.toLowerCase().endsWith('@cps.edu')) {
                 this.suggestSamlLogin = true;
                 // Show CPS redirect suggestion instead of auto-redirect
                 this.showCpsRedirectNotification();
             }
         },
                 clearSamlError() {
             this.samlError = null;
             // Clear URL parameters
             const url = new URL(window.location);
             url.searchParams.delete('error');
             window.history.replaceState({}, document.title, url.toString());
         },
         
         autoRedirectToCps() {
             if (this.suggestSamlLogin) {
                 // Show notification and redirect after short delay
                 this.showCpsRedirectNotification();
                 setTimeout(() => {
                     this.redirectToSamlLogin();
                 }, 2000);
             }
         },
         
         showCpsRedirectNotification() {
             // Show toast notification about CPS SSO availability
             if (window.M && window.M.toast) {
                 window.M.toast({
                     html: 'CPS email detected. You can use CPS SSO to sign in.',
                     classes: 'blue',
                     displayLength: 3000
                 });
             }
         },
         
         trackSamlLogin() {
             // Track SAML login attempts
             if (window.gtag) {
                 window.gtag('event', 'saml_login_attempt', {
                     event_category: 'authentication',
                     event_label: 'cps_saml'
                 });
             }
             
             // Or use existing analytics system
             console.log('SAML login attempt tracked');
         },
         
         checkForSamlError() {
             // Check URL parameters for SAML errors
             const urlParams = new URLSearchParams(window.location.search);
             const error = urlParams.get('error');
             
             if (error === 'saml_auth_failed') {
                 this.samlError = 'SAML authentication failed. Please try again or contact support.';
                 this.showErrorToast('SAML authentication failed');
             }
         },
         
         showErrorToast(message) {
             // Use existing toast notification system
             if (window.M && window.M.toast) {
                 window.M.toast({html: message, classes: 'red'});
             }
         }
    }
};
</script>
<style lang="sass">
    // Login card and the forgot-password dialog are light. The dialog is
    // portaled outside #loginPage, so it needs the same token override.
    #loginPage, .reset-password-modal
        --input-bg: #fff
        --input-txt: #005B9A
        --app-primary-txt: #005B9A
        --app-tertiary-txt: #005B9A
        --score-blue-color: #005B9A
        .haq-field
            margin: 8px 0 16px
            .haq-field__label
                color: #005B9A
                opacity: 0.8
            .haq-field__control
                .v-input__slot
                    background: #fff !important
                    border-color: #005B9A !important
                .v-select__selections,
                .v-select__selection,
                input,
                textarea
                    color: #005B9A !important
                    caret-color: #005B9A !important
                input::placeholder
                    color: #005B9A !important
                    opacity: 0.4
                .v-icon
                    color: #005B9A !important
                &.v-input--is-focused .v-input__slot
                    border-color: #005B9A !important
                    box-shadow: inset 0 0 0 1px #005B9A !important

    .login-haq-select-menu
        background: #fff !important
        .v-list
            background: #fff !important
        .v-list-item
            color: #005B9A !important
        .v-list-item__title
            color: #005B9A !important
        .v-list-item--highlighted,
        .v-list-item--active
            background: rgba(0, 91, 154, 0.08) !important
</style>
<style lang="sass" scoped>
    #loginPage, .reset-password-modal
        background: #fff url("../../public/images/bg.png") top right no-repeat
        background-size: cover
        min-height: 100vh
        
    .header-nav
        background: #fff
        box-shadow: 0px 100px 80px rgba(0, 91, 154, 0.12), 0px 41.7776px 33.4221px rgba(0, 91, 154, 0.0862625), 0px 22.3363px 17.869px rgba(0, 91, 154, 0.0715329), 0px 12.5216px 10.0172px rgba(0, 91, 154, 0.06), 0px 6.6501px 5.32008px rgba(0, 91, 154, 0.0484671), 0px 2.76726px 2.21381px rgba(0, 91, 154, 0.0337375)
        display: flex
        align-items: center
        justify-content: space-between
        height: 80px
        padding: 18px 36px
        
        @media (max-width: 600px)
            padding: 18px 15px

        img
            max-height: 52px
        a.contact-us
            border: 1px solid #005B9A
            border-radius: 12px
            color: #005B9A
            font: normal 400 16px/24px Roboto
            letter-spacing: 0.18px
            height: 40px
            line-height: 40px
            text-align: center
            width: 140px
            @media (max-width: 600px)
                font-size: 14px
                height: 36px
                line-height: 36px
                width: 90px
    .login-cards
        display: flex
        align-items: center
        min-height: calc(100vh - 80px)
        
        @media (max-width: 600px)
            align-items: flex-start

        .login-card
            background: #fff
            border-radius: 20px
            box-shadow: 0px 100px 80px rgba(0, 91, 154, 0.12), 0px 41.7776px 33.4221px rgba(0, 91, 154, 0.0862625), 0px 22.3363px 17.869px rgba(0, 91, 154, 0.0715329), 0px 12.5216px 10.0172px rgba(0, 91, 154, 0.06), 0px 6.6501px 5.32008px rgba(0, 91, 154, 0.0484671), 0px 2.76726px 2.21381px rgba(0, 91, 154, 0.0337375)
            color: #005B9A
            margin: 50px auto
            max-height: 604px
            max-width: 548px
            padding: 40px
            width: 100%

            @media (max-width: 600px)
                // background: rgba(255,255,255,.8)
                margin: 50px 15px
                padding: 40px 20px

            .content
                margin: 0 auto
                max-width: 360px
                width: 100%
                text-align: center

                .title
                    font: normal 400 32px/46px Roboto
                    margin-bottom: 32px
                    @media (max-width: 600px)
                        font-size: 24px
                .input-group
                    text-align: left
                    label
                        font: normal 400 14px/20px Roboto
                        color: #005B9A
                    input
                        border: 1px solid #005B9A
                        box-sizing: border-box
                        border-radius: 12px
                        color: #005B9A
                        font: normal 400 16px/24px Roboto
                        margin: 8px 0 24px
                        padding: 8px 20px
                    ::placeholder
                        color: #005B9A
                        opacity: 0.4
                .error
                    background-color: transparent !important
                    color: #FF5050
                    font: normal 400 14px/20px Roboto
                    text-align: left
                .strike
                    display: block
                    text-align: center
                    overflow: hidden
                    white-space: nowrap
                    > span
                        color: #005B9A
                        font: normal 400 14px/20px Roboto
                        position: relative
                        display: inline-block
                        opacity: 0.5
                        &:before,
                        &:after
                            content: ""
                            position: absolute
                            top: 55%
                            width: 9999px
                            height: 1px
                            background: #005B9A
                            opacity: 0.5
                        &:before
                            right: 100%
                            margin-right: 8px
                        &:after
                            left: 100%
                            margin-left: 8px
            .reset-password
                .input-field
                    margin: 0 0 16px
                    text-align: left
                    label
                        font: normal 400 14px/20px Roboto
                        color: #005B9A
                        position: static
                        margin-bottom: 8px
                    input
                        border: 1px solid #005B9A
                        box-sizing: border-box
                        box-shadow: none
                        border-radius: 12px
                        color: #005B9A
                        font: normal 400 16px/24px Roboto
                        height: 40px
                        margin: 0 
                        padding: 8px 20px
                        &:disabled
                            color: #acacac
                            border-color: #ccc
                    span.field-icon
                        position: absolute
                        right: 12px
                        top: 33px
                        cursor: pointer
                        z-index: 2
                        .material-icons
                            font-size: 20px
                    span.helper-text
                        color: #005B9A
                        font: normal 400 12px/20px Roboto
                    ::placeholder
                        color: #005B9A
                        font: normal 400 14px/20px Roboto
                        opacity: 0.4
                .if-pw-confirm
                    margin-bottom: 0
                .requirements
                    text-align: left
                    font: normal 400 12px/20px Roboto
                .error
                    background-color: transparent !important
                    color: #FF5050
                    font: normal 400 14px/20px Roboto
                    text-align: left
                .strike
                    display: block
                    text-align: center
                    overflow: hidden
                    white-space: nowrap
                    > span
                        color: #005B9A
                        font: normal 400 14px/20px Roboto
                        position: relative
                        display: inline-block
                        opacity: 0.5
                        &:before,
                        &:after
                            content: ""
                            position: absolute
                            top: 55%
                            width: 9999px
                            height: 1px
                            background: #005B9A
                            opacity: 0.5
                        &:before
                            right: 100%
                            margin-right: 8px
                        &:after
                            left: 100%
                            margin-left: 8px
        #loginBtn,
        #chooseProjectBtn,
        #createProjectBtn,
        #confirmCreateProject,
        #reset-password-button
            background: #3456F7
            border: 0
            border-radius: 12px
            color: #fff
            margin: 24px 0
            padding: 10px
            height: 40px
            max-height: 360px
            width: 100%
            .disabled
                background: #B9E2FF
                color: #52B2F3
        
        #googleBtn
            background: #fff
            border: 1px solid #005B9A
            border-radius: 12px
            color: #005B9A
            font: normal 400 14px/20px 'Roboto'
            padding: 10px
            height: 40px
            max-height: 360px
            margin: 24px 0
            width: 100%
            
        // SAML login styles
        .saml-login-section
            margin: 20px 0
            
            .saml-login-btn
                background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)
                border: none
                border-radius: 12px
                color: white
                cursor: pointer
                font: normal 400 16px/24px 'Roboto'
                height: 40px
                padding: 10px 24px
                transition: all 0.3s ease
                width: 100%
                display: flex
                align-items: center
                justify-content: center
                gap: 8px
                
                &:hover
                    transform: translateY(-2px)
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15)
                    
                &:disabled
                    opacity: 0.7
                    cursor: not-allowed
                    transform: none
                    
                i
                    font-size: 18px
                    
        .auth-divider
            text-align: center
            margin: 0px
            position: relative
            
            &::before
                content: ''
                position: absolute
                top: 50%
                left: 0
                right: 0
                height: 1px
                background: #e0e0e0
                z-index: 1
                
            span
                background: white
                padding: 0 15px
                color: #666
                position: relative
                z-index: 2
                
        .cps-login-suggestion
            background: #e3f2fd
            border: 1px solid #1976d2
            border-radius: 12px
            padding: 12px
            margin: 10px 0
            color: #1976d2
            
            .suggestion-text
                font-size: 14px
                margin-bottom: 8px
                
            .suggestion-actions
                display: flex
                gap: 10px
                
                .btn-small
                    padding: 6px 12px
                    font-size: 12px
                    border-radius: 6px
                    border: none
                    cursor: pointer
                    
                .btn-primary
                    background: #1976d2
                    color: white
                    
                .btn-secondary
                    background: white
                    color: #1976d2
                    border: 1px solid #1976d2
                    
        .error-banner
            background: #ffebee
            border: 1px solid #f44336
            border-radius: 12px
            padding: 12px
            margin: 10px 0
            color: #c62828
            
            .error-content
                display: flex
                align-items: center
                gap: 8px
                
                .error-close
                    background: none
                    border: none
                    color: #c62828
                    cursor: pointer
                    font-size: 18px
                    margin-left: auto
                    
        // Responsive design for mobile
        @media (max-width: 768px)
            .saml-login-section .saml-login-btn
                padding: 10px 20px
                font-size: 14px
                
            .cps-login-suggestion
                padding: 10px
                
                .suggestion-actions
                    flex-direction: column
                    gap: 8px
                    
                    .btn-small
                        width: 100%
</style>